// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2TOKA","inner":"Footer_inner__1geln"};